import { __assign, __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
var play_triangle = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 60 60", fill: "currentColor", width: size || "60", height: size || "60" }, props),
        React.createElement("path", { d: "M41.5,30l-17,10V20L41.5,30z" })));
};
play_triangle.displayName = 'play_triangle';
play_triangle.propTypes = {
    size: PropTypes.string
};
export default play_triangle;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=play_triangle.js.map